import Typography from "@mui/material/Typography";
import { CostEstimate } from "./CostEstimate";
import type { JSX } from "react";

export function AnchorTopicEstimate(props: { anchorsText: string }) {
  let anchorTopicEstimate: JSX.Element | null;
  const estimate = CostEstimate.anchorTopicGroupEstimate(props.anchorsText);
  if (estimate === null) {
    anchorTopicEstimate = null;
  } else {
    anchorTopicEstimate = (
    <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
      Ориентировочная стоимость генерации: {CostEstimate.formatEstimate(estimate.uniqueArticles, estimate.cost)}
    </Typography>
  );
  }
  return anchorTopicEstimate;
}
